<template>
  <ul class="pagination mb-12" v-if="count / perPage > 1">
    <template v-if="last > bulletCount && start >= bulletCount - 1">
      <li @click="setCurrent(0)"><div class="bullet">1</div></li>
      <li v-if="start >= bulletCount">…</li>
    </template>
    <li v-for="index in displayedBullet" :key="index" @click="setCurrent(index - 1)">
      <div class="bullet" :class="{current: current === index - 1}">{{index}}</div>
    </li>
    <template v-if="start + bulletCount <= last">
      <li v-if="start + bulletCount < last">…</li>
      <li @click="setCurrent(last - 1)"><div class="bullet">{{last}}</div></li>
    </template>
  </ul>
</template>
<style lang="sass" scoped>
.pagination
  @apply flex justify-center
  .bullet
    @apply cursor-pointer mx-3 inline-flex justify-center items-center w-8 h-8 text-xs bg-white
    &.current
      @apply bg-accent text-white
</style>
<script>
export default {
  props: {
    count: { type: Number, required: true },
    value: { type: Number, required: true },
    perPage: { type: Number, required: true }
  },
  computed: {
    bulletCount() {
      const { last } = this;
      return Math.min(3, last);
    },
    start() {
      const { current, last, bulletCount } = this;
      let start = current;
      if(start + bulletCount > last) {
        start = last - bulletCount + 1;
      }
      if(start < bulletCount - 1) {
        start = 1;
      }
      return start;
    },
    last() {
      const { count, perPage } = this;
      return Math.ceil(count / perPage);
    },
    displayedBullet() {
      const { start, bulletCount } = this;
      const array = [start];
      for (let c = 1; c < bulletCount; c++ ) {
        array.push(c + start);
      }
      return array;
    },
    current: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v);
      }
    }
  },
  methods: {
    setCurrent(v) {
      this.current = v
      this.$scrollTo('#__layout')
    }
  }
}
</script>
